import { getApp } from 'firebase/app';

export default function getCollectionWithAlt(model: any, useAlt: boolean = false): any {
  if (!model?.collectionRef || !model?.collectionRef()?.path) {
    throw new Error('Model does not have a collectionRef');
  }

  if (!useAlt) {
    return model.collectionRef();
  }

  try {

    const altApp: any = getApp('alt');

    if (altApp) {
      return altApp.firestore().collection(model.collectionRef().path);
    }
  } catch (error) {
    console.error('Failed to use alternate Firestore instance:', error);
  }

  // Fallback to main collection
  return model.collectionRef();
}